import React from 'react'

const Pledge = () => {
  return (
    <>
      <div style={{ fontSize: "40px", marginTop: "200px" }}>Pledge</div>
      <div style={{ fontSize: "40px", marginTop: "10px" }}>Coming Soon...</div>
    </>
  )
}

export default Pledge